import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { SimpleSelect } from '@calendly/ui/components/select'
import { BodyText } from '@calendly/ui/components/typography'

const getOptions = () => [
  { id: 'existing', name: I18n.t('publisher.event_type_editor.sections.availability.multiple_hosts.set_by_host') },
  { id: 'custom', name: I18n.t('publisher.event_type_editor.sections.availability.multiple_hosts.same_for_all_hosts') }
]

export const MultiHostScheduleSelect = ({ isLocked }) => {
  const [{ value }, _, { setValue }] = useFormField({ name: 'userRuleType' })
  const options = getOptions()
  const scheduleLabel = options.find((option) => option.id === value).name

  if (isLocked) return <BodyText size="medium">{scheduleLabel}</BodyText>

  return (
    <SimpleSelect
      aria-label={`${I18n.t('publisher.action.change')} ${scheduleLabel}`}
      variant="minimal"
      value={value}
      onChange={(id) => setValue(id)}
      options={options}
    />
  )
}
